import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { showSuccessToast } from '../../app/utils/tostify';
import {
	accountInformation,
	addShipingLabel,
	addSingleOrGropTax,
	addTaxInfo,
	deleteTax,
	editSingleOrGropTax,
	updateAppSetting
} from '../apis/configurationAPIs';
import configuration from '../../app/constants/configuration';
interface CategoryState {
	loading: boolean;
	error: string;
	appSetting: any;
	reasonList: any;
}
const initialState: CategoryState = {
	loading: false,
	error: '',
	appSetting: null,
	reasonList: []
};
const configurationSlice = createSlice({
	name: 'category',
	initialState,
	reducers: {
		// tempOTP(state, action: any) {
		// 	state.tempOTP = action.payload;
		// },
	},
	extraReducers: (builder) => {
		builder.addCase(addShipingLabel.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addShipingLabel.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addShipingLabel.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(updateAppSetting.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			accountInformation.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				if (action?.meta?.arg?.type === configuration.appSetting) {
					state.appSetting = action.payload || null;
				}
			}
		);
		builder.addCase(accountInformation.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(accountInformation.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			updateAppSetting.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(updateAppSetting.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(addTaxInfo.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addTaxInfo.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addTaxInfo.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(addSingleOrGropTax.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			addSingleOrGropTax.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(addSingleOrGropTax.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(editSingleOrGropTax.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			editSingleOrGropTax.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccess({ message: t(action.payload.message) });
			}
		);
		builder.addCase(
			editSingleOrGropTax.rejected,
			(state: CategoryState) => {
				state.loading = false;
			}
		);
		builder.addCase(deleteTax.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(
			deleteTax.fulfilled,
			(state: CategoryState, action: any) => {
				state.loading = false;
				showSuccessToast({ message: t(action.payload.message) });
			}
		);
		builder.addCase(deleteTax.rejected, (state: CategoryState) => {
			state.loading = false;
		});
	}
});
// export const {
//     // logout,
//     // loginData,
//     // saveDeviceToken,
//     // setSessionExpired,
//     // usingMobile,
//     // currentlyUsing,
//     // tempOTP,
//     // setCurrentUserRole,
//     // updateUserInfo,
//     // updateAccessToken,
//     // updateTokenTime
// } = categorySlice.actions;
export default configurationSlice.reducer;
